import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Local from '../assets/images/local.svg';
import GlobalPlan from '../assets/images/Globalplan.svg';
import Regional from '../assets/images/Regional.svg';
import QRCode from 'qrcode.react'; // Use qrcode.react for QR code generation
import { IoMdSearch } from "react-icons/io";
import { toast } from 'react-toastify';

const InventoryPlan = () => {
  const [vendors, setVendors] = useState([]);
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("createplandetails");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [planName, setPlanName] = useState("");
  const [planType, setPlanType] = useState("");
  const [countryList, setCountryList] = useState("");
  const [dataLimit, setDataLimit] = useState("");
  const [validity, setValidity] = useState("");
  const [planClass, setPlanClass] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [createdPlans, setCreatedPlans] = useState([]);
  const [selected, setSelected] = useState();
  const [showModal, setShowModal] = useState(false); // State to toggle modal visibility
  const [qrCodeData, setQrCodeData] = useState(""); // State for QR code data
  const [isAlertVisible, setIsAlertVisible] = useState(false); // For handling alert visibility

  useEffect(() => {
    const storedVendors = JSON.parse(localStorage.getItem("vendors"));
    const storedPlans = JSON.parse(localStorage.getItem("createdPlans"));
    if (storedVendors) setVendors(storedVendors);
    if (storedPlans) setCreatedPlans(storedPlans);
  }, []);

  useEffect(() => {
    if (vendors.length > 0) localStorage.setItem("vendors", JSON.stringify(vendors));
    if (createdPlans.length > 0) localStorage.setItem("createdPlans", JSON.stringify(createdPlans));
  }, [vendors, createdPlans]);

  const handleCreatePlan = () => {
    if (!selectedVendor || !planName || !dataLimit) {
      return toast.error("Please fill all the fields.");
    }

    const newPlan = {
      vendor: selectedVendor,
      planName,
      planType,
      countryList,
      dataLimit,
      validity,
      planClass,
      additionalInfo,
      sellingPrice,
    };

    setCreatedPlans([...createdPlans, newPlan]);
    setPlanName("");
    setPlanType("");
    setCountryList("");
    setDataLimit("");
    setValidity("");
    setPlanClass("");
    setAdditionalInfo("");
    setSellingPrice("");
  };

  const handleNavigation = (storeType) => {
    setSelected(storeType);

    if (storeType === "local") {
      navigate("/BuyStandardplan");
    } else if (storeType === "regional") {
      navigate("/BuyPremiumplan");
    } else if (storeType === "customplan") {
      navigate("/InventoreCustomPlan");
    } else {
      navigate("/BuyDataGlobal");
    }
  };

  const handleBuyPlan = (plan) => {
    // Show the alert message for 2 seconds
    setIsAlertVisible(true);
    setTimeout(() => {
      setIsAlertVisible(false); // Hide alert after 2 seconds
      // Show the QR code modal after alert
      setQrCodeData(`Plan: ${plan.planName}, Vendor: ${plan.vendor}, Price: $${plan.sellingPrice}`);
      setShowModal(true);
    }, 2000); // Alert will disappear after 2 seconds
  };

  // Close the modal
  const closeModal = () => {
    setShowModal(false);
    setQrCodeData(""); // Clear QR code data when closing the modal
  };

  return (
    <>
     
         <div className="flex items-center">

      <div className="flex">
        <button
      onClick={() => handleNavigation("regional")}
      className="rounded-lg h-10 flex items-center p-2 border border-gray-600 m-2"
    >
      <img
        src={Local}
        className="h-6 w-6 mr-2 filter invert sepia saturate-500 hue-rotate-180 brightness-150 contrast-100"
        alt="Regional Icon"
      />
      Premium Plans
    </button>

      <button
              onClick={() => handleNavigation("local")}
                   className="rounded-lg h-10 flex items-center p-2 border border-gray-600 m-2"

            >
              <img
                src={Local}
                className="h-6 w-6 filter invert sepia saturate-500 hue-rotate-180 brightness-150 contrast-100 mr-2"
                alt="Basic Plans"
              />
              Standard Plans
            </button>
        <button
          onClick={() => handleNavigation("customplan")}
              className={`rounded-lg h-10 flex flex-row items-center p-2 border border-gray-600 m-2 ${
            selected === "customplan" ? "bg-brand-white text-brand-green-selected" : "bg-brand-green-selected text-brand-white"
          }`}
     >
          <img
            src={Local}
            className={`h-6 w-6 mr-2 ${selected === "customplan" ? "text-brand-green-selected" : "text-gray-400"}`}
            alt="Regional Icon"
          />
          Custom Plans
        </button>
      </div>
       {/* Spacer to push search to right */}
        <div className="flex-grow" />
      
        {/* Search Bar */}
         <div className="bg-[#117575] p-3 mb-2 w-96 rounded-xl">
                   <div className="relative">
                     <input
                       type="text"
                       placeholder="Search Countries"
                       className="w-full rounded-2xl bg-brand-gray h-8 pl-10"
                    
                     />
                     <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                       <IoMdSearch size={20} className="text-gray-500" />
                     </div>
                   </div>
                 </div>
      </div>
      <h2 className="text-5xl font-bold text-gray-700 ">Create Plan</h2>

      {/* Plan Details Table */}
      {viewMode === "createplandetails" && (
        <div className="overflow-x-auto bg-white">
          <table className="min-w-full border-collapse table-auto">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-6 py-3 text-center">Vendor</th>
                <th className="px-6 py-3 text-center">Plan Type</th>
                <th className="px-6 py-3 text-center">Country</th>
                <th className="px-6 py-3 text-center">Data Limit</th>
                <th className="px-6 py-3 text-center">Validity (Days) </th>
                <th className="px-6 py-3 text-center">Plan Class</th>
                <th className="px-6 py-3 text-center">Selling Price</th>
                <th className="px-6 py-3 text-center">Buy</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-6 py-4 text-center">Partner</td>
                <td className="px-6 py-4 text-center">Local</td>
                <td className="px-6 py-4 text-center">Italy</td>
                <td className="px-6 py-4 text-center">5 GB</td>
                <td className="px-6 py-4 text-center">15 Days</td>
                <td className="px-6 py-4 text-center">Data</td>
                <td className="px-6 py-4 text-center">$15</td>
                <td className="px-6 py-4 text-center">
                  <button onClick={() => handleBuyPlan({planName: "Local Plan",vendor: "Partner",sellingPrice: "15",})}className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected flex flex-row items-center justify-center p-2.5 box-border text-brand-white"
                  >Buy</button>
                </td>
              </tr>
              <tr>
                <td className="px-6 py-4 text-center">Partner</td>
                <td className="px-6 py-4 text-center">Regional</td>
                <td className="px-6 py-4 text-center">UK</td>
                <td className="px-6 py-4 text-center">30 GB</td>
                <td className="px-6 py-4 text-center">15 Days</td>
                <td className="px-6 py-4 text-center">Data</td>
                <td className="px-6 py-4 text-center">$150</td>
                <td className="px-6 py-4 text-center">
                  <button onClick={() => handleBuyPlan({planName: "Local Plan",vendor: "Partner",sellingPrice: "15",})}className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected flex flex-row items-center justify-center p-2.5 box-border text-brand-white"
                  >Buy</button>
                </td>
              </tr>
              {createdPlans.map((plan, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 text-center">{plan.vendor}</td>
                  <td className="px-6 py-4 text-center">{plan.planType}</td>
                  <td className="px-6 py-4 text-center">{plan.countryList}</td>
                  <td className="px-6 py-4 text-center">{plan.dataLimit} GB</td>
                  <td className="px-6 py-4 text-center">{plan.validity} Days</td>
                  <td className="px-6 py-4 text-center">{plan.planClass}</td>
                  <td className="px-6 py-4 text-center">${plan.sellingPrice}</td>
                  <td className="px-6 py-4 text-center">
                    <button
                      onClick={() => handleBuyPlan(plan)}
                      className="self-stretch shadow-[0px_2px_8px_rgba(92,_152,_140,_0.3)] rounded-xl bg-brand-green-selected flex flex-row items-center justify-center p-2.5 box-border text-brand-white"
                    >
                      Buy
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Alert */}
      {isAlertVisible && (
        <div className="fixed top-0 left-1/2 transform -translate-x-1/2 bg-green-500 text-white p-4 rounded-lg shadow-lg z-50">
          Plan Purchased Successfully!
        </div>
      )}

      {/* Modal for displaying the QR Code */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg">
            <h3 className="text-xl font-bold mb-4">Purchase QR Code</h3>
            <QRCode value={qrCodeData} size={256} />
            <div className="mt-4 text-center">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InventoryPlan;
